import { render } from "./IconATMFilters.vue?vue&type=template&id=37d7b820&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconATMFilters.vue?vue&type=script&lang=js"
export * from "./IconATMFilters.vue?vue&type=script&lang=js"
script.render = render

export default script